import { create } from 'zustand';

import { createSelectors } from '../../../utils/store';

type AudioState = {
  audioInstance: HTMLAudioElement | null;
  isMuted: boolean;
  initAudio: () => void;
  playAudio: (arrayBuffer: ArrayBuffer) => void;
  playAudioAlt: (url: string) => void;
  stopAudio: () => void;
  toggleMute: () => void;
};

export const useAudioStore = createSelectors(
  create<AudioState>((set, get) => ({
    audioInstance: null,
    isMuted: true,

    initAudio: () => {
      if (!get().audioInstance) {
        const audio = new Audio();
        audio.autoplay = false;
        set({ audioInstance: audio });
      }
    },

    playAudio: (arrayBuffer) => {
      const { audioInstance, isMuted, stopAudio, initAudio } = get();
      if (isMuted || !audioInstance) return;

      if (!audioInstance) {
        initAudio();
        return; // skip for now, re-trigger once audio is ready
      }

      stopAudio();

      const blob = new Blob([arrayBuffer], { type: 'audio/mpeg' });
      console.log('Playing audio from buffer:', blob);
      audioInstance.srcObject = null; // Clear any previous source
      audioInstance.src = ''; // Clear the src to avoid caching issues
      const url = URL.createObjectURL(blob);
      console.log('Playing audio from URL:', url);
      audioInstance.src = url;
      audioInstance.play().catch(console.error);
    },
    playAudioAlt: (url) => {
      const { audioInstance, isMuted, stopAudio, initAudio } = get();
      if (isMuted || !audioInstance) return;

      if (!audioInstance) {
        initAudio();
        return; // skip for now, re-trigger once audio is ready
      }

      stopAudio();

      audioInstance.srcObject = null; // Clear any previous source
      audioInstance.src = ''; // Clear the src to avoid caching issues
      console.log('Playing audio from URL:', url);
      audioInstance.src = url;
      audioInstance.play().catch(console.error);
    },

    stopAudio: () => {
      const { audioInstance } = get();
      if (audioInstance) {
        audioInstance.pause();
        audioInstance.currentTime = 0;
        audioInstance.src = '';
      }
    },

    toggleMute: () => {
      const { isMuted, stopAudio } = get();
      if (!isMuted) stopAudio();
      set({ isMuted: !isMuted });
    },
  })),
);
